import styled from 'styled-components';
import { COLORS } from '../../../colors';

const StyledFooter = styled.footer`
    text-align: center;
    background-color: ${COLORS.darkerBlue};
    color: white;
    padding: 4rem;
    img#footer-logo {
      width: 150px;
    }
    .links, .links-secondary {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;

      //only smartphone
      @media only screen and (max-width: 600px) {
        flex-direction: column;
      }
      a {
        color: white;
      }
    }

    .links {
      font-size: 18px;
    }

    .links-secondary {
      margin-top: 1rem;
      font-size: 12px;
    }

    .social {
      width: fit-content;
      margin: auto;
      padding: 0.5rem 1rem;
      border-radius: 12px;
      gap: 1rem;
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      background-color: white;
    }
    .credits {
      padding-top: 2rem;
      font-size: 12px;
      a {
        color: white;
      }

  }
`;

export {
    StyledFooter
}
